const mapboxgl = require("mapbox-gl");
const segmentInsert = require("@mapbox/segmentio-insert");
const shipLines = require("./data/ShipLines.geojson");
const intro = require("./img/intro-tpsdave.jpg");
const approach = require("./img/approach-lynngreyling.jpg");
const pilot = require("./img/pilot-publicdomain.jpg");
const traffic = require("./img/traffic-sagesolar.jpg");
const port = require("./img/port-eugenekim.jpg");
const shallow = require("./img/shallow-christieandsteve.jpg");

mapboxgl.accessToken = "pk.eyJ1IjoibGFicy1zYW5kYm94IiwiYSI6ImNrMTZuanRxMTAxMjUzbXFhMXo2dGo1cmMifQ.PfUaWJqRAy5jqN7MuBU6Nw";
const analytics = segmentInsert("fl0c8p240n");
analytics.track("Demo Viewed", { name: "sf_ships" });

let currentTourStop = null;
const tourStops = [
  {
    title: "Ships in the SF Bay",
    cameraOptions: {
      center: [-122.435017, 37.831146],
      bearing: 0,
      pitch: 0,
      zoom: 8.9,
      speed: 0.3
    },
    description: "How do big ships navigate the San Francisco Bay? The tracks on this map show telemetry data from 24 hours of activity archived by the US Coast Guard on September 1st, 2014, along with underwater bathymetry (depth) data provided by NOAA. Ship telemetry data has been anonymized by the USCG, so relative ship sizes are approximated based on their general behavior.",
    image: intro,
    "image-credit": "Photo by <a href='https://pixabay.com/en/golden-gate-bridge-suspension-1596161/' target='_blank'>tpsdave on Pixabay</a>",
    layers: [],
    highlight_ships: "all"
  },
  {
    title: "Approach",
    cameraOptions: {
      center: [-123.117592, 37.944438],
      bearing: 121.08,
      zoom: 11.37,
      pitch: 60,
      speed: 0.3
    },
    timestamp: 1409596870,
    description: "As ship approach the entrance to the Bay, they line up within designated traffic lanes to avoid collisions in this congested zone. The official navigation charts note these traffic lanes and separation lines so that the captain can safely set a course for the approach.",
    layers: ["traffic_lanes", "pilot_rendezvous", "Highlight-Oil-Tankers", "Highlight-Container-Ships"],
    image: approach,
    "image-credit": "Photo by <a href='http://www.publicdomainpictures.net/view-image.php?image=190846&picture=container-ship' target='_blank'>Lynne Greyling in the public domain</a>",
    // highlight_ships: ["Pilot Boats", "Container Ships", "Oil Tankers", "Cruise Ships"]
    highlight_ships: ["Oil Tankers", "Container Ships"]
  },
  {
    title: "Pilot Rendezvous",
    cameraOptions: {
      center: [-122.658923, 37.764644],
      bearing: 70,
      zoom: 11.26,
      pitch: 40,
      speed: 0.3
    },
    timestamp: 1409561297,
    description: `Any ship over a certain size cannot enter most harbors, including the San Francisco Bay, without being guided by a professional harbor pilot who has intimate knowledge of the navigational hazards specific to the area. The challenge begins just outside the Golden Gate with treacherous shallow sand bars that give the <a href='http://sfbarpilots.com/' target='_blank'>San Francisco Bar Pilots</a> their name. The harbor pilot meets a waiting ship just beyond the sand bars at the pilot rendezvous point. Getting a harbor pilot aboard is a dangerous job as it requires the pilot to climb up a rope ladder strung on the side of a massive cargo ship as it pitches and rolls in open ocean swells.`,
    image: pilot,
    "image-credit": "Photo by <a href='https://commons.wikimedia.org/wiki/File:U.S._Sailors_assigned_to_the_guided_missile_Cruiser_USS_Chosin_(CG_65)_set_up_a_ladder_to_bring_aboard_a_harbor_pilot_to_help_the_ship_navigate_the_water_into_Changi_Naval_Base_in_Singapore_Aug._26,_2013_130826-N-WT787-007.jpg' target='_blank'>US Military via Wikimedia</a>",
    layers: ["traffic_lanes", "pilot_rendezvous", "Highlight-Pilot-Boats"],
    highlight_ships: ["Pilot Boats"]
  },
  {
    title: "Traffic in the Bay",
    cameraOptions: {
      center: [-122.441231, 37.820334],
      bearing: 0,
      zoom: 12.72,
      pitch: 0,
      speed: 0.3
    },
    timestamp: 1409610588,
    description: "Inside the Golden Gate, vessel traffic of all sizes zips from shore to shore. High speed ferries make regular crossings from San Francisco to destinations in Marin County and the East Bay. Tourist ferries shuttle sightseers to Alcatraz Island or underneath the Golden Gate Bridge. Big ships generally move along predictable routes travelling counter-clockwise around Alcatraz. No matter what happens, smaller boats must yield right of way to the big ships as they have limited maneuverability in close quarters.",
    image: traffic,
    "image-credit": "Photo by <a href='https://www.flickr.com/photos/sagesolar/8479268476/' target='_blank'>sagesolar on Flickr</a>",
    // layers: ["traffic_lanes", "navigation_buoys", "Highlight-Container-Ships", "Highlight-Oil-Tankers", "Highlight-Cruise-Ships"],
    layers: [],
    highlight_ships: ["Container Ships", "Oil Tankers", "Cruise Ships"]
  },
  {
    title: "At Anchor",
    cameraOptions: {
      center: [-122.344309, 37.755415],
      bearing: 0,
      pitch: 0,
      zoom: 13.08,
      speed: 0.3
    },
    description: "Once arriving in the Bay, a ship may have to wait before its destination port is ready to unload its cargo. This is especially true for oil and gas tankers, who must wait in a specially designated \"anchorage for explosives\" in the South Bay. The circular patterns shown here are formed as the ships spin around with the daily tides. From the city's eastern shore, you can see these ships fully lit up at night as they wait under anchor.",
    layers: ["mooring", "special_anchorage", "Highlight-Oil-Tankers"],
    highlight_ships: ["Oil Tankers"]
  },
  {
    title: "Port",
    cameraOptions: {
      center: [-122.29490817094208, 37.79550146922831],
      bearing: -50,
      zoom: 13.68,
      pitch: 60,
      speed: 0.3
    },
    timestamp: 1409587452,
    description: `There are many ports within the San Francisco Bay. Each one handles a different type of cargo. As a ship approaches its designated berth, its harbor pilot must skillfully bring it to rest, adjusting its course for the tides, currents, wind, and other factors. Also visible towards the bottom of this view is a <a href='https://en.wikipedia.org/wiki/Turning_basin' target='_blank'>turning basin</a>, a section of the Oakland estuary that has been widened and dredged so big ships can turn around 180 degrees in the otherwise narrow channel.`,
    image: port,
    "image-credit": "Photo by <a href='https://commons.wikimedia.org/wiki/File:Ever_Champion_(ship,_2005)_001.jpg' target='_blank'>Eugene Kim via Wikimedia</a>",
    layers: ["navigation_buoys", "Highlight-Container-Ships"],
    highlight_ships: ["Container Ships"]
  },
  {
    title: "Shallow Waters",
    cameraOptions: {
      center: [-122.350825, 37.869217],
      bearing: 0,
      pitch: 0,
      zoom: 11.81,
      speed: 0.3
    },
    description: "Not all of the bay is navigable to large ships. Some regions, such as the area between Richmond and Emeryville, are much too shallow for deep draft ships to pass— as little as one meter in some places. The only traffic you will see here is from smaller pleasure craft, such as a powerboat returning from China Camp State Park to the Berkeley Marina, or a sailing vessel (tracing a telltale zig-zag pattern as it tacks upwind) touring a popular route around Angel Island. Only boats over 60ft in length are required by law to transmit AIS telemetry data, so many smaller boats do not appear on this map.",
    layers: ["navigation_buoys", "Highlight-Pleasure-Craft"],
    image: shallow,
    "image-credit": "Photo by <a href='https://www.flickr.com/photos/39146306@N00/9584453307/' target='_blank'>christieandsteve on Flickr</a>",
    highlight_ships: ["Pleasure Craft"]
  }

];
const shipFilters = {
  "Pilot Boats": [
    366031978,
    367000173
  ],

  "Container Ships": [
    367048031,
    367363686,
    367605187,
    477000669,
    366005307,
    566000014,
    357600700
  ],
  "Oil Tankers": [
    563626000,
    538000639,
    351857000,
    538000828,
    355332000,
    538500186,
    367107016,
    367000547,
    210060050,
    432000172
  ],
  "Tugs": [
    366793903,
    367374790,
    367025003,
    367048031,
    367079936,
    367693017,
    367374790,
    366998803,
    366998803,
    366899015,
    338185201,
    366709971,
    367313500
  ],
  "Ferries": [
    367358405,
    366033895,
    366905928,
    367332809,
    367530005
  ],
  "Cruise Ships": [
    311600050
  ],
  "Pleasure Craft": [
    367125060,
    367454309,
    367654802,
    367701661
  ]
};
const animationSettings = {
  "timestamp_start": 1409554742,
  "timestamp_end": 1409618978,
  "timestamp_now": 1409618978,
  "seconds_per_frame": 15,
  "animating": true,
  "ship_data": []
};

const map = new mapboxgl.Map({
  container: "map",
  style: "mapbox://styles/labs-sandbox/ck48p1uqm28l91cn6ch6zyavm?fresh=true",
  center: tourStops[0].cameraOptions.center,
  zoom: tourStops[0].cameraOptions.zoom
});

map.on("load", () => {
  if (window.location.search.indexOf("embed") !== -1) map.scrollZoom.disable();
  setupUI();
  showTourStop(tourStops[0]);

  map.setMaxBounds([
    [-125.09033203124999, 36.53612263184686],
    [-121.431884765625, 38.95940879245423]
  ]);

  // Set up data-driven styling for different depths
  map.setPaintProperty("Depth Area", "fill-color", {
    property: "DRVAL1",
    stops: [
      [0, "#493854"],
      [17, "#1a0f21"]
    ]
  });

  map.setPaintProperty("Depth Area", "fill-opacity", {
    stops: [
      [9, 0.01],
      [11, 0.25],
      [15, 1.0]
    ]
  });

  // Download ship track data to create animations
  fetch(shipLines).then(res => res.json())
    .then(data => {
      setupAnimations(data);
      setupClock();
    });
});

function setupUI() {
  for (let i = 0; i < tourStops.length; i++) {
    const stop = tourStops[i];
    const test = document.createElement("div");
    test.setAttribute("class", "tourStop");
    const stopEl = $(test);
    const stopH2 = document.createElement("h2");
    stopH2.setAttribute("class", "green");
    const stopH2Text = document.createTextNode(`${stop["title"]}`);
    stopH2.appendChild(stopH2Text);
    stopEl.append(stopH2);
    stopEl.data("stop", stop);

    if (stop["image"] != null) {
      const imgDiv = document.createElement("div");
      imgDiv.setAttribute("class", "image");
      const imgContainer = $(imgDiv);
      const imageEl = document.createElement("img");
      imageEl.setAttribute("src", `${stop["image"]}`);
      const imgEl = $(imageEl);
      imgContainer.append(imgEl);
      if (stop["image-credit"] != null) {
        imgContainer.append(stop["image-credit"]);
      }
      stopEl.append(imgContainer);
    }

    stopEl.append(stop["description"]);

    if (window.location.search.indexOf("embed") === -1) {
      const nextElP = document.createElement("p");
      const nextElDiv = document.createElement("div");
      nextElDiv.setAttribute("class", "button fill-navy-dark");
      const nextElDivText = document.createTextNode("Next ->");
      nextElDiv.appendChild(nextElDivText);
      nextElP.appendChild(nextElDiv);
      const nextEl = $(nextElP);
      nextEl.on("click", advanceTourStop);
      stopEl.append(nextEl);
    }
    $("#narrative").append(stopEl);
  }

  $("#narrative").on("scroll", () => {
    // Find the tourStop that is closest to the top
    let closestStop = null;
    let closestDistance = Number.MAX_VALUE;
    $("#narrative .tourStop").each((idx, el) => {
      const dist = Math.abs($(el).offset().top);
      if (dist < closestDistance) {
        closestStop = $(el).data("stop");
        closestDistance = dist;
      }
    });
    if (closestStop != null) {
      showTourStop(closestStop);
    }
  });

  $(".button.playback.speed").on("click", ev => {
    const speed = $(ev.target).data("speed");
    animationSettings.seconds_per_frame = speed;
  });
}

function showTourStop(stop) {
  if (stop === currentTourStop) return;
  const oldTourStop = currentTourStop;
  currentTourStop = stop;

  const trace_highlight_color = "#0cdf80";
  const trace_normal_color = "#476255";


  // New way to do this filter is to selectively show/hide layers
  if (stop["highlight_ships"] === "all") {
    // Special case to highlight all traces
    map.setPaintProperty("Ship-Traces", "line-color", trace_highlight_color);
  } else {
    map.setPaintProperty("Ship-Traces", "line-color", trace_normal_color);
    // Fade out old tour stop's highlight layers, fade in current tour stop's layers
    for (let i = 0; i < oldTourStop["layers"].length; i++) {
      const layer = map.getLayer(oldTourStop["layers"][i]);
      if (layer === undefined) continue;
      if (layer.paint["fill-opacity"] !== undefined) {
        map.setPaintProperty(oldTourStop["layers"][i], "fill-opacity", 0);
      }
      if (layer.paint["line-opacity"] !== undefined) {
        map.setPaintProperty(oldTourStop["layers"][i], "line-opacity", 0);
      }
      if (layer.paint["text-opacity"] !== undefined) {
        map.setPaintProperty(oldTourStop["layers"][i], "text-opacity", 0);
      }

      map.setLayoutProperty(oldTourStop["layers"][i], "visibility", "none");

    }

    for (let i = 0; i < stop["layers"].length; i++) {
      const layer = map.getLayer(stop["layers"][i]);
      if (layer === undefined) continue;
      if (layer.paint["fill-opacity"] !== undefined) {
        map.setPaintProperty(stop["layers"][i], "fill-opacity", 1);
      }
      if (layer.paint["line-opacity"] !== undefined) {
        map.setPaintProperty(stop["layers"][i], "line-opacity", 1);
      }
      if (layer.paint["text-opacity"] !== undefined) {
        map.setPaintProperty(stop["layers"][i], "text-opacity", 1);
      }

      map.setLayoutProperty(stop["layers"][i], "visibility", "visible");
    }


  }

  map.flyTo(stop["cameraOptions"]);
  if (stop["timestamp"] != null) {
    map.once("moveend", () => {
      setTime(stop["timestamp"]);
    });
  }
}

function advanceTourStop() {
  const direction = 1;
  const stopEl = $($(this).parent());
  let nextStop = direction > 0 ? stopEl.next() : stopEl.prev();
  let duration = 1000;
  if (nextStop.length === 0) {
    // No next/prev stop... so jump to first/last
    nextStop = direction > 0 ? stopEl.siblings().first() : stopEl.siblings().last();
    duration = 5000;
  }
  $("#narrative").animate({ "scrollTop": ($(nextStop).offset().top + $("#narrative").scrollTop() - 40) + "px" }, duration);
}

function setupAnimations(data) {
  // Pre-process the data:
  // 1. Calculate min/max timestamp to set animation range
  // 2. Tag each feature with ship size & color based on handmade filters
  data.features.forEach(feature => {
    animationSettings.timestamp_start = Math.min(animationSettings.timestamp_start, feature.properties.startTime);
    animationSettings.timestamp_end = Math.max(animationSettings.timestamp_end, feature.properties.endTime);

    let shipType = "none";
    for (const t in shipFilters) {
      if (shipFilters[t].indexOf(feature.properties.MMSI) >= 0) {
        shipType = t;
        break;
      }
    }

    feature.properties.type = shipType;
    if (shipType === "Oil Tankers" || shipType === "Container Ships" || shipType === "Cruise Ships") {
      feature.properties.scale = 10;
      feature.properties.shipIconType = "large";
    } else if (shipType === "Ferries" || shipType === "Tugs" || shipType === "Pilot Boats") {
      feature.properties.scale = 5;
      feature.properties.shipIconType = "medium";
    } else {
      feature.properties.scale = 1;
      feature.properties.shipIconType = "small";
    }
  });

  animationSettings.timestamp_now = animationSettings.timestamp_start; // Start at the start

  // Save this dataset for future animation frames
  animationSettings.ship_data = data;


  // Build a set of initial points from the data
  map.addSource("ship-points", {
    "type": "geojson",
    "data": generateCurrentShipGeojson(data)
  });

  map.addLayer({
    "id": "ship-positions",
    "type": "symbol",
    "source": "ship-points",
    "layout": {
      "icon-image": "ship-{shipIconType}",
      "icon-allow-overlap": true,
      "icon-ignore-placement": true,
      "icon-size": {
        stops: [
          [8, 0.12],
          [13, 0.45],
          [17, 0.9]
        ]
      },
      "icon-rotate": {
        property: "heading",
        stops: [
          [-360, -360],
          [0, 0],
          [360, 360]
        ]
      },
      "icon-rotation-alignment": "map"
    }
  });

  animate();
}

function generateCurrentShipGeojson(data, settings) {
  if (typeof(settings) === "undefined") settings = animationSettings;
  const out = {
    "type": "FeatureCollection",
    "features": []
  };

  data.features.forEach(feature => {
    // TODO: Calculate index based on animation settings and progress
    let progress = (settings.timestamp_now - feature.properties.startTime) / (feature.properties.endTime - feature.properties.startTime);
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;
    const idx = progress * feature.geometry.coordinates.length - 1;
    const point_a = feature.geometry.coordinates[Math.floor(idx)];
    const point_b = feature.geometry.coordinates[Math.ceil(idx)];
    const interpolate = idx - Math.floor(idx);

    let coord = [0, 0];

    if (typeof(point_a) !== "undefined" && typeof(point_b) !== "undefined") {
      coord = [
        (point_b[0] - point_a[0]) * interpolate + point_a[0],
        (point_b[1] - point_a[1]) * interpolate + point_a[1]
      ];

      if (feature.properties.heading == null) feature.properties.heading = 0;
      // Calculate current heading and ease towards it
      if (idx > 0);
      const dP = [point_b[0] - point_a[0], point_b[1] - point_a[1]];
      const mag = dP[0] * dP[0] + dP[1] * dP[1];
      if (mag > 0.00000005) { // Don't update heading for ships that aren't moving; it's distracting
        const targetHeading = -Math.atan2(dP[1], dP[0]) * 180 / Math.PI + 90;
        let dH = targetHeading - feature.properties.heading;
        if (dH > 180) dH -= 360; // Prevent spinouts
        if (dH < -180) dH += 360;
        feature.properties.heading += (dH) * 0.5;

        if (feature.properties.heading > 360) feature.properties.heading -= 360;
        if (feature.properties.heading < -360) feature.properties.heading += 360;
      }
    }

    out.features.push({
      "type": "Feature",
      "geometry": {
        "type": "Point",
        "coordinates": coord
      },
      "properties": {
        "scale": feature.properties.scale,
        "shipIconType": feature.properties.shipIconType,
        "type": feature.properties.type,
        "heading": feature.properties.heading
      }
    });

  });

  return out;

}

function requestAnimation(e) {
  if (e.dataType === "source") {
    map.getSource("ship-points").off("data", requestAnimation);
    window.requestAnimationFrame(animate);
  }
}

function animate() {
  if (animationSettings.animating) {
    setTime(animationSettings.timestamp_now + animationSettings.seconds_per_frame);
  }

  map.getSource("ship-points").on("data", requestAnimation);

  // Get current ship positions and cull out those that are not on screen
  const currentShips = generateCurrentShipGeojson(animationSettings.ship_data);
  const visibleFeatures = [];
  currentShips.features.forEach(feat => {
    const p = map.project(feat.geometry.coordinates);
    if (p.x >= 0 && p.x <= map.transform.width && p.y >= 0 && p.y <= map.transform.height) {
      visibleFeatures.push(feat);
    }
  });
  currentShips.features = visibleFeatures;
  map.getSource("ship-points").setData(currentShips);
}

function setTime(timestamp) {
  animationSettings.timestamp_now = timestamp;
  // Loop
  if (animationSettings.timestamp_now > animationSettings.timestamp_end) {
    animationSettings.timestamp_now = animationSettings.timestamp_start;
  }

  setClockTime(animationSettings.timestamp_now);
}

function setClockTime(timestamp) {
  const date = new Date(timestamp * 1000);
  const hours = date.getHours();
  const minutes = date.getMinutes();
  const seconds = date.getSeconds();

  const minuteAngle = (minutes + seconds / 60) / 60 * 360;
  const hourAngle = (hours + ((minutes + seconds / 60) / 60)) / 24 * 360;
  $("#clockMinuteHand").attr("transform", "rotate(" + minuteAngle + ")");
  $("#clockHourHand").attr("transform", "rotate(" + hourAngle + ")");
}

function setupClock() {
  $("#clock").svg({ onLoad: function(svg) {
    const width = $("#clock").width();
    const height = $("#clock").height();
    const clock = svg.group({
      transform: "translate(" + (width / 2) + "," + (height / 2) + ")"
    });
    const face = svg.group(clock, {
      fill: "none",
      stroke: "white",
      strokeWidth: 1
    });
    svg.circle(face, 0, 0, width * 0.4);
    for (let i = 0; i < 24; i++) {
      const angle = i / 24 * Math.PI * 2;
      svg.line(face, Math.cos(angle) * width * 0.37, Math.sin(angle) * width * 0.37,
        Math.cos(angle) * width * 0.35, Math.sin(angle) * width * 0.35);
    }

    const hourHand = svg.line(clock, 0, 0, 0, -width * 0.2, {
      stroke: "white",
      strokeWidth: 4,
      strokeLineCap: "round"
    });

    const minuteHand = svg.line(clock, 0, 0, 0, -width * 0.3, {
      stroke: "white",
      strokeWidth: 2.5,
      strokeLineCap: "round",
      transform: "rotate(45)"
    });

    $(hourHand).attr("id", "clockHourHand");
    $(minuteHand).attr("id", "clockMinuteHand");
  } });

  $("#clock svg").mousedown(() => {
    $(this).data("dragging", true);

    animationSettings.animating = !animationSettings.animating;
  }).mousemove(ev => {
    if ($(this).data("dragging")) {
      const relX = ev.pageX - $(this).offset().left - $(this).width() / 2;
      const relY = ev.pageY - $(this).offset().top - $(this).height() / 2;
      let angle = Math.atan2(relY, relX) * 180 / Math.PI + 90;
      if (angle < 0) angle += 360;
      // Set time
      setTime(animationSettings.timestamp_start + (angle / 360 * 24 * 60 * 60));

      animationSettings.animating = false;
    }
  }).mouseup(() => {
    $(this).data("dragging", false);
    // animationSettings.animating = true;
  });
}
